export const TipoArchivo = {
	CARPETA: "CARPETA",
	DOCUMENTO: "DOCUMENTO"
};
